import React from "react";

function AboutUs() {
  return (
    <div>
      <div className="about-us-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-5">
              <div className="overview-img text-center img-hover_effect">
                <a href="#">
                  <img
                    className="img-full"
                    src="../../images/about_us.webp"
                    alt="Kenne's About Us Image"
                  />
                </a>
              </div>
            </div>
            <div className="col-lg-6 col-md-7 d-flex align-items-center">
              <div className="overview-content">
                <h2>
                  Welcome To <span>The fantom's</span> Store!
                </h2>
                <p className="short_desc">
                  We Provide Lorem ipsum, dolor sit amet consectetur adipisicing
                  elit. Repudiandae nisi fuga facilis, consequuntur, maiores
                  eveniet voluptatum, omnis possimus temporibus aspernatur nobis
                  animi in exercitationem vitae nulla! Adipisci ullam illum
                  quisquam. Lorem ipsum dolor sit amet, consectetur adipisicing
                  elit. Dolorem, nulla veniam? Magni aliquid asperiores magnam.
                  Veniam ex tenetur.
                </p>
                <div className="kenne-about-us_btn-area">
                  <a className="about-us_btn" href="shop-left-sidebar.html">
                    Shop Now
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="project-count-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="single-count text-center">
                <div className="count-icon">
                  <span className="ion-ios-briefcase-outline"></span>
                </div>
                <div className="count-title">
                  <h2 className="count">2169</h2>
                  <span>Project Done</span>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="single-count text-center">
                <div className="count-icon">
                  <span className="ion-ios-wineglass-outline"></span>
                </div>
                <div className="count-title">
                  <h2 className="count">869</h2>
                  <span>Awards Winned</span>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="single-count text-center">
                <div className="count-icon">
                  <span className="ion-ios-lightbulb-outline"></span>
                </div>
                <div className="count-title">
                  <h2 className="count">689</h2>
                  <span>Hours Worked</span>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="single-count text-center">
                <div className="count-icon">
                  <span className="ion-happy-outline"></span>
                </div>
                <div className="count-title">
                  <h2 className="count">2169</h2>
                  <span>Happy Customer</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="team-area">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="section_title-2">
                <h3>Our Team</h3>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="team-member">
                <div className="team-thumb img-hover_effect">
                  <a href="#">
                    <img src="../../images/team-1.webp" alt="Our Team Member" />
                  </a>
                </div>
                <div className="team-content text-center">
                  <h3>Edwin Adams</h3>
                  <p>IT Expert</p>
                  <a href="#">info@example.com</a>
                  <div className="kenne-social_link">
                    <ul>
                      <li className="facebook">
                        <a
                          href="https://www.facebook.com"
                          data-bs-toggle="tooltip"
                          title="Facebook"
                        >
                          <i className="fab fa-facebook"></i>
                        </a>
                      </li>
                      <li className="twitter">
                        <a
                          href="https://twitter.com"
                          data-bs-toggle="tooltip"
                          title="Twitter"
                        >
                          <i className="fab fa-twitter-square"></i>
                        </a>
                      </li>
                      <li className="youtube">
                        <a
                          href="https://www.youtube.com"
                          data-bs-toggle="tooltip"
                          title="Youtube"
                        >
                          <i className="fab fa-youtube"></i>
                        </a>
                      </li>
                      <li className="google-plus">
                        <a
                          href="https://www.plus.google.com/discover"
                          data-bs-toggle="tooltip"
                          title="Google Plus"
                        >
                          <i className="fab fa-google-plus"></i>
                        </a>
                      </li>
                      <li className="instagram">
                        <a
                          href="https://rss.com"
                          data-bs-toggle="tooltip"
                          title="Instagram"
                        >
                          <i className="fab fa-instagram"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="team-member">
                <div className="team-thumb img-hover_effect">
                  <a href="#">
                    <img src="../../images/team-2.webp" alt="Our Team Member" />
                  </a>
                </div>
                <div className="team-content text-center">
                  <h3>Anny Adams</h3>
                  <p>Web Designer</p>
                  <a href="#">info@example.com</a>
                  <div className="kenne-social_link">
                    <ul>
                      <li className="facebook">
                        <a
                          href="https://www.facebook.com"
                          data-bs-toggle="tooltip"
                          title="Facebook"
                        >
                          <i className="fab fa-facebook"></i>
                        </a>
                      </li>
                      <li className="twitter">
                        <a
                          href="https://twitter.com"
                          data-bs-toggle="tooltip"
                          title="Twitter"
                        >
                          <i className="fab fa-twitter-square"></i>
                        </a>
                      </li>
                      <li className="youtube">
                        <a
                          href="https://www.youtube.com"
                          data-bs-toggle="tooltip"
                          title="Youtube"
                        >
                          <i className="fab fa-youtube"></i>
                        </a>
                      </li>
                      <li className="google-plus">
                        <a
                          href="https://www.plus.google.com/discover"
                          data-bs-toggle="tooltip"
                          title="Google Plus"
                        >
                          <i className="fab fa-google-plus"></i>
                        </a>
                      </li>
                      <li className="instagram">
                        <a
                          href="https://rss.com"
                          data-bs-toggle="tooltip"
                          title="Instagram"
                        >
                          <i className="fab fa-instagram"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="team-member">
                <div className="team-thumb img-hover_effect">
                  <a href="#">
                    <img src="../../images/team-1.webp" alt="Our Team Member" />
                  </a>
                </div>
                <div className="team-content text-center">
                  <h3>Edvin Adams</h3>
                  <p>Content Writer</p>
                  <a href="javascript:void(0)">info@example.com</a>
                  <div className="kenne-social_link">
                    <ul>
                      <li className="facebook">
                        <a
                          href="https://www.facebook.com"
                          data-bs-toggle="tooltip"
                          title="Facebook"
                        >
                          <i className="fab fa-facebook"></i>
                        </a>
                      </li>
                      <li className="twitter">
                        <a
                          href="https://twitter.com"
                          data-bs-toggle="tooltip"
                          title="Twitter"
                        >
                          <i className="fab fa-twitter-square"></i>
                        </a>
                      </li>
                      <li className="youtube">
                        <a
                          href="https://www.youtube.com"
                          data-bs-toggle="tooltip"
                          title="Youtube"
                        >
                          <i className="fab fa-youtube"></i>
                        </a>
                      </li>
                      <li className="google-plus">
                        <a
                          href="https://www.plus.google.com/discover"
                          data-bs-toggle="tooltip"
                          title="Google Plus"
                        >
                          <i className="fab fa-google-plus"></i>
                        </a>
                      </li>
                      <li className="instagram">
                        <a
                          href="https://rss.com"
                          data-bs-toggle="tooltip"
                          title="Instagram"
                        >
                          <i className="fab fa-instagram"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="team-member">
                <div className="team-thumb img-hover_effect">
                  <a href="#">
                    <img src="../../images/team-2.webp" alt="Our Team Member" />
                  </a>
                </div>
                <div className="team-content text-center">
                  <h3>Eddy Adams</h3>
                  <p>Marketing officer</p>
                  <a href="#">info@example.com</a>
                  <div className="kenne-social_link">
                    <ul>
                      <li className="facebook">
                        <a
                          href="https://www.facebook.com"
                          data-bs-toggle="tooltip"
                          title="Facebook"
                        >
                          <i className="fab fa-facebook"></i>
                        </a>
                      </li>
                      <li className="twitter">
                        <a
                          href="https://twitter.com"
                          data-bs-toggle="tooltip"
                          title="Twitter"
                        >
                          <i className="fab fa-twitter-square"></i>
                        </a>
                      </li>
                      <li className="youtube">
                        <a
                          href="https://www.youtube.com"
                          data-bs-toggle="tooltip"
                          title="Youtube"
                        >
                          <i className="fab fa-youtube"></i>
                        </a>
                      </li>
                      <li className="google-plus">
                        <a
                          href="https://www.plus.google.com/discover"
                          data-bs-toggle="tooltip"
                          title="Google Plus"
                        >
                          <i className="fab fa-google-plus"></i>
                        </a>
                      </li>
                      <li className="instagram">
                        <a
                          href="https://rss.com"
                          data-bs-toggle="tooltip"
                          title="Instagram"
                        >
                          <i className="fab fa-instagram"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AboutUs;
